import {apiRequest} from '../utils/apiHelper'
import {API_URL_RESOURCE} from '../utils/constants'

export const validateMilestone = async order => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + `cliententity/validatemilestone/${order}`
    )
    return (
        response.hasOwnProperty('error') &&
        (Object.keys(response.error).length > 0 ? response : response.success)
    )
}

export const getClientEnrollmentStatus = async () => {
    const response = await apiRequest(API_URL_RESOURCE.URL + `clientprogram/enrollment`)
    console.log('getClientEnrollmentStatus -------->', response)
    return (
        response.hasOwnProperty('error') &&
        (Object.keys(response.error).length > 0
            ? false
            : response.success.enrollmentcomplete)
    )
}

export const getMyAccountURL = async () => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + `myaccount/clientprogram/manage/19`
    )
    return (
        response.hasOwnProperty('error') &&
        (Object.keys(response.error).length > 0 ? false : response.success)
    )
}
